import React from 'react';
import About from '../About/About';
import Footer from '../Footer/Footer';
import Navbar from '../Navbar';
import Projects from '../Projects/Projects';

const Home = () => {
    return (
        <div>
            <Navbar/>
            <About/>
            <Projects/>
            <Footer/>
        </div>
    );
};

export default Home;